import { z } from "zod";

export const MarketNetworkSchema = z.object({
  name: z.string(),
  network: z.string(),
  withdrawFee: z.string().nullable().optional(),
  withdrawMax: z.string().nullable().optional(),
  withdrawMin: z.string().nullable().optional(),
  withdrawalEnabled: z.boolean(),
  depositEnabled: z.boolean(),
  chainId: z.number().nullable().optional(),
  iconUrl: z.string(),
});

export type MarketNetwork = z.infer<typeof MarketNetworkSchema>;
